'use strict';
import {runInjector} from '../_libs/angular-utils/index';
import {ChatMessageInputComponent} from './components/ChatMessageInput/ChatMessageInputComponent';
import {CommentIndicatorComponent} from './components/CommentIndicator/CommentIndicatorComponent';
import {UserChannelList} from './components/UserChannelList';
// eslint-disable-next-line max-len
import {injector as VideoCallStartModalContainerInjector} from './components/VideoCallStartModal/VideoCallStartModalContainer';
import {VideoChatSession} from './components/VideoChatSession';
import {UserConversationsController} from './controllers/UserConversationsController';
import {VideoChatController} from './controllers/VideoChatController';
import {CommentDomainProvider} from './domain/CommentDomain';
import {ConversationDomainProvider} from './domain/ConversationDomain';
import {routerConfig} from './router';
import {VideoSessionService} from './services/VideoSessionService';


const angular = require('angular');

// Components
const CommentIndicatorDirective = require('./directives/CommentIndicatorDirective.js');
const CommentIndicatorContainerDirective = require('./directives/CommentIndicatorContainerDirective.js');

module.exports = angular
  .module('app.comments', [])
  .config(routerConfig)
  .value('CommentIndicatorComponent', CommentIndicatorComponent)
  .run(runInjector(ChatMessageInputComponent))
  .run(runInjector(CommentIndicatorComponent))
  .run(VideoCallStartModalContainerInjector)
  .value('VideoChatSession', VideoChatSession)
  .value('UserChannelList', UserChannelList)

  .provider('ConversationDomain', ConversationDomainProvider)
  .provider('CommentDomain', CommentDomainProvider)
  .service(VideoSessionService.NAME, VideoSessionService)

  .directive('commentIndicator', CommentIndicatorDirective.directive)
  .controller('CommentIndicatorController', CommentIndicatorDirective.controller)
  .directive('commentIndicatorContainer', CommentIndicatorContainerDirective.directive)

  .controller('UserConversationsController', UserConversationsController)
  .controller('VideoChatController', VideoChatController)
;



// WEBPACK FOOTER //
// ./src/js/comments/index.js